// extracted by mini-css-extract-plugin
module.exports = {"header":"sucession-view_header__3cWAv","succession_view":"sucession-view_succession_view__3JC38"};